import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, FormControl } from 'react-bootstrap'
import IntlCurrencyInput from "./currencyInput"

const FieldInputMask = ({ input, name, label, meta: { touched, error, warning }, focus, inputGroup, isDisabled, handleChange, maskInput, valorInicial, referencia}) => {
    return (
        <>
            <Form.Label htmlFor={name}>{label}</Form.Label>
            <InputGroup>
                {inputGroup ? <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">{inputGroup}</InputGroup.Text>
                </InputGroup.Prepend> : null}

                {
                    
                    !!handleChange ?

                        <IntlCurrencyInput className="form-control"
                            currency="BRL"  
                            name={name}
                            disabled={isDisabled}
                            onChange={handleChange}
                            config={maskInput}
                            defaultValue={valorInicial}
                            ref={referencia}

                        /> :
                        <IntlCurrencyInput className="form-control"
                            currency="BRL"
                            name={name}
                            disabled={isDisabled}
                            config={maskInput}
                            defaultValue={valorInicial}
                        />

                }

            </InputGroup>
            {touched && ((error && <p className="text-danger">{error}</p>) || (warning && <p className="text-danger">{warning}</p>))}
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </>
    );
};

FieldInputMask.propTypes = {
    input: PropTypes.object.isRequired,
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    focus: PropTypes.bool,
    isDisabled: PropTypes.bool,
    handleChange: PropTypes.func,
    valorDefault: PropTypes.string,
    maskInput: PropTypes.string
};



export default FieldInputMask;
